const cdnFor = (hash) => `https://cdn11.bigcommerce.com/s-${hash}`;
const bcStorefront = (hash) => `https://store-${hash}.mybigcommerce.com`;

export const STORES = [
  {
    label: "US",
    hash: "ww3msiylzo",
    name: "United States",
    baseUrl: cdnFor("ww3msiylzo"),
    storefrontUrl: bcStorefront("ww3msiylzo"),
  },
  {
    label: "UK",
    hash: "h658uhfy9j",
    name: "United Kingdom",
    baseUrl: cdnFor("h658uhfy9j"),
    storefrontUrl: bcStorefront("h658uhfy9j"),
  },
  {
    label: "EU",
    hash: "dwdwr5marw",
    name: "International",
    baseUrl: cdnFor("dwdwr5marw"),
    storefrontUrl: bcStorefront("dwdwr5marw"),
  },
  {
    label: "DE",
    hash: "llmy6cysh9",
    name: "Germany",
    baseUrl: cdnFor("llmy6cysh9"),
    storefrontUrl: bcStorefront("llmy6cysh9"),
  },
  {
    label: "UAT",
    hash: "eb52p33wq0",
    name: "UAT (sandbox)",
    baseUrl: cdnFor("eb52p33wq0"),
    storefrontUrl: bcStorefront("eb52p33wq0"),
  },
];

export const STORE_LABELS = STORES.map((s) => s.label);

export const hashForLabel = (label) =>
  STORES.find((s) => s.label === label)?.hash || "";

export const labelForHash = (hash) =>
  STORES.find((s) => s.hash === hash)?.label || "";

export const baseUrlForStore = ({ storeHash, storeLabel } = {}) => {
  const byHash = STORES.find((s) => s.hash === storeHash);
  if (byHash) return byHash.baseUrl;
  const byLabel = STORES.find((s) => s.label === storeLabel);
  return byLabel?.baseUrl || "";
};

export const resolveImageUrl = (path, store) => {
  if (!path) return "";
  if (/^https?:\/\//i.test(path)) return path;
  const base = baseUrlForStore(store);
  if (!base) return path;
  return `${base}${path.startsWith("/") ? "" : "/"}${path}`;
};

export const storefrontUrlForStore = ({ storeHash, storeLabel } = {}) => {
  const byHash = STORES.find((s) => s.hash === storeHash);
  if (byHash) return byHash.storefrontUrl;
  const byLabel = STORES.find((s) => s.label === storeLabel);
  return byLabel?.storefrontUrl || "";
};

export const resolveBlogUrl = (path, store) => {
  if (!path) return "";
  if (/^https?:\/\//i.test(path)) return path;
  const base = storefrontUrlForStore(store);
  if (!base) return path;
  return `${base}${path.startsWith("/") ? "" : "/"}${path}`;
};

export { DEFAULT_STORE_LABEL as DEFAULT_STORE } from "../common/storeDefaults";
